import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()((theme) => ({
    closeButton: {
        height: '30px',
    },
    icon: {
        display: 'flex',
        flexDirection: 'column',
        '& img': {
            height: '20px',
            marginBottom: theme.spacing(1),
        },
    },
    label: {
        display: 'inline-flex',
        '& img': {
            height: '14px',
            marginRight: theme.spacing(0.5),
        },
    },
}));
export default useStyles;
